import vuex from '@/store'

const $modal = {
  show(name, params = {}) {
    vuex.dispatch('showModal', { name, params })
  },
  hide(name) {
    vuex.dispatch('hideModal', name)
  },
  hideAll() {
    vuex.dispatch('hideAllModals')
  },
  toggle(name, params = {}) {
    vuex.dispatch('toggleModal', { name, params })
  },
  register(name) {
    vuex.dispatch('registerModal', name)
  }
}

export default $modal
